const question1 = {
    'question': 'Kiedy warto zasięgnąć pomocy u terapeuty par?',
    'answer': '<p>Spotkania ze specjalistą mogą  pomóc usprawnić wzajemną komunikację, zrozumieć drugą połowę oraz jej zachowania, a także znaleźć kompromisy, które są podstawą trwałego związku.</p>' +
        '<p>W przypadku, gdy samodzielne próby odbudowania związku nie przynoszą rezultatu warto zgłosić się po pomoc do osoby, która wskaże właściwą drogę w pracy nad kształtowaniem zdrowej relacji między partnerami.</p>',
}

export default question1;